import * as z from 'zod'

export type RuleId = 'minLength' | 'lowercase' | 'uppercase' | 'number' | 'specialChar'

export const passwordRules: Record<RuleId, z.ZodString> = {
  minLength: z.string().min(8, 'Password must be at least 8 characters long'),
  lowercase: z.string().regex(/[a-z]/, 'Password must contain at least one lowercase letter'),
  uppercase: z.string().regex(/[A-Z]/, 'Password must contain at least one uppercase letter'),
  number: z.string().regex(/\d/, 'Password must contain at least one number'),
  specialChar: z
    .string()
    .regex(
      /[!@#$%^&*()_+={}|<>?~-]/,
      'Password must contain at least one special character (!@#$%^&*()_+={}|<>?~-)',
    ),
}
export const passwordRulesList: RuleId[] = [
  'minLength',
  'lowercase',
  'uppercase',
  'number',
  'specialChar',
]
